module.exports = __webpack_public_path__ + "static/media/button.8ee1753f.mp3";